<template>
  <div class="tab-content-inner">
    <div class="info-alert info-alert--accent">
      <CIcon name="cil-building" class="info-icon" />
      <div>
        <strong>Contexto do Negócio:</strong> descreva o segmento e perfil dos seus clientes.
        A IA usará este contexto para interpretar melhor termos informais e gírias do dia-a-dia.
        Ex: "Somos uma distribuidora de material de construção. Nossos clientes são pedreiros e lojistas que usam linguagem informal."
      </div>
    </div>

    <div class="form-group">
      <label>Prompt de Contexto do Negócio</label>
      <textarea
        class="form-control contexto-textarea"
        :value="parametro.prompt_contexto_negocio"
        @input="update({ prompt_contexto_negocio: $event.target.value })"
        placeholder="Ex: Somos uma distribuidora de material de construção e acabamento. Nossos clientes são pedreiros, encanadores, eletricistas e lojistas que usam linguagem informal do dia-a-dia da obra. Exemplos comuns: 'cano' = tubo PVC, 'barra' = unidade de tubo/vergalhão, 'massa' = argamassa, 'fio' = cabo elétrico."
      ></textarea>
      <small class="form-text text-muted">
        Este texto é injetado automaticamente no início de toda análise da IA, ajudando a interpretar termos informais dos clientes.
      </small>
    </div>

    <hr class="section-divider" />

    <div class="info-alert">
      <CIcon name="cil-info" class="info-icon" />
      <div>
        <strong>Prompt de Sugestão final de Pedido:</strong> usado para "filtrar" os itens que foram encontrados de acordo com o prompt do usuário e que fazem sentido com a solicitação.
      </div>
    </div>

    <div class="form-group">
      <label>Prompt de Sugestão de Pedido</label>
      <textarea
        class="form-control prompt-textarea"
        :value="parametro.prompt_sugestao_pedido"
        @input="update({ prompt_sugestao_pedido: $event.target.value })"
        placeholder="Insira o prompt de sugestão de pedido..."
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "tab-prompts",
  props: {
    parametro: {
      type: Object,
      required: true,
    },
  },
  methods: {
    update(changes) {
      this.$emit("update", changes);
    },
  },
};
</script>

<style scoped>
.tab-content-inner {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
}

.contexto-textarea {
  min-height: 120px;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
}

.prompt-textarea {
  min-height: 300px;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
}

.section-divider {
  margin: 24px 0;
  border-color: #e4e7eb;
}

.info-alert {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #edf8f9;
  border: 1px solid #c5e6e9;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #344054;
  line-height: 1.5;
}

.info-alert--accent {
  background: #f2f2f8;
  border-color: #dddce9;
}

.info-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #2298a3;
}

.info-alert--accent .info-icon {
  color: #3a3e81;
}
</style>
